import script from "./UiOtpInput.vue?vue&type=script&setup=true&lang=js"
export * from "./UiOtpInput.vue?vue&type=script&setup=true&lang=js"

import "./UiOtpInput.vue?vue&type=style&index=0&id=5acef330&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5acef330"]])

export default __exports__